import { useState, useEffect } from 'react';
import { DataStore } from 'aws-amplify';
import { TripSheet } from '../models';
import { TripSheetProps, convertTripSheetToProps } from '../datastore/tripSheets';

export default function useObserveTripSheets() {
  const [tripSheets, setTripSheets] = useState<TripSheetProps[]>([]);

  useEffect(() => {
    const retrieveData = async () => {
      console.log('useObserveTripSheets: Querying TripSheets from DataStore...');
      const entities = await DataStore.query(TripSheet);
      console.log('useObserveTripSheets: Raw entities fetched:', entities.length);
      console.log('useObserveTripSheets: First entity:', entities[0]);

      const validTripSheets = entities
        .map((t) => convertTripSheetToProps(t))
        .filter((t): t is TripSheetProps => t !== undefined);

      console.log('useObserveTripSheets: Valid tripsheets after conversion:', validTripSheets.length);
      setTripSheets(validTripSheets);
    };
    const subscription = DataStore.observe(TripSheet).subscribe(retrieveData);
    retrieveData();
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return tripSheets;
}
